import axios from 'axios';

const submitImage = async (url, form) => {
    // const response = await axios.post(url, form);
    const response = await axios({
        method: 'post',
        url: url,
        data: form,
        headers: {
            'Content-Type': 'image/png'
        }
    });

    return response.status;
};

export default submitImage;
